<template>
    <div class="loader--spinner"></div>
</template>

<script>
  export default {
    name: 'small-loader'
  }
</script>

<style lang="scss" scoped>

    .loader--spinner {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 100%;
        position: relative;
        margin: 0 auto;

        &::before, &::after {
            content: "";
            position: absolute;
            top: -1px;
            left: -1px;
            width: 100%;
            height: 100%;
            border-radius: 100%;
            border: 1px solid transparent;
            border-top-color: #3498db;
        }

        &::before {
            z-index: 100;
            animation: spin 1s infinite;
        }
        &::after {
            border: 1px solid #ccc;
        }
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Loaders/SmallLoader.vue